declare const WeixinJSBridge: any;

export namespace WechatSDK {
  export function canJSBridge() {
    return typeof WeixinJSBridge !== 'undefined';
  }
  export function executePay(input: {
    appId: string;
    timeStamp: string;
    nonceStr: string;
    package: string;
    signType: string;
    paySign: string;
  }) {
    return new Promise<any>((resolve, reject) => {
      //加载支付参数
      function onBridgeReady() {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          input,
          function (res: any) {
            const message = res.errMsg ?? res.err_msg;
            if (message === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              resolve('ok');
            } else if (message === 'get_brand_wcpay_request:cancel') {
              //取消支付
              // window.location.href = '${fromUrl}';
              resolve('cancel');
            } else {
              //上报失败
              reject(message);
            }
          },
        );
      }
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            onBridgeReady,
            false,
          );
        }
      } else {
        onBridgeReady();
      }
    });
  }
}
